import { render, staticRenderFns } from "./TopUserForm.vue?vue&type=template&id=032c4b36&scoped=true"
import script from "./TopUserForm.vue?vue&type=script&lang=js"
export * from "./TopUserForm.vue?vue&type=script&lang=js"
import style0 from "./TopUserForm.vue?vue&type=style&index=0&id=032c4b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c4b36",
  null
  
)

export default component.exports